import { render, staticRenderFns } from "./videoCommentAction.vue?vue&type=template&id=3146cc69"
import script from "./videoCommentAction.vue?vue&type=script&lang=js"
export * from "./videoCommentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports